import { render, staticRenderFns } from "./changeCurrenrPhone.vue?vue&type=template&id=537b23de&scoped=true"
import script from "./changeCurrenrPhone.vue?vue&type=script&lang=js"
export * from "./changeCurrenrPhone.vue?vue&type=script&lang=js"
import style0 from "./changeCurrenrPhone.vue?vue&type=style&index=0&id=537b23de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537b23de",
  null
  
)

export default component.exports